<template>
  <div class="top-wrapper-reset-password">
    <div class="columns v-align reset-confirm-flex-row">
      <div v-if="$mq.desktop" class="column is-3">
        <div v-if="success">
          <svg-icon name="success" width="250" height="150"></svg-icon>
        </div>
        <div v-else-if="errors.length">
          <svg-icon width="250" height="150" name="triangle-warning"></svg-icon>
        </div>
      </div>
      <div v-if="success" class="column is-narrow info-text">
        <h2 v-translate :class="$mq.phone ? 'heading-3' : 'heading-2'" class="paragraph-bold">
          Success!
        </h2>
        <p v-translate :class="$mq.phone ? 'paragraph-m' : 'paragraph-l'" class="confirmation-text">
          You have successfully updated your password. Now you can login.
        </p>
        <div>
          <router-link v-translate :to="loginRoute" class="button is-primary">
            Login
          </router-link>
        </div>
      </div>
      <div v-if="!success && errors" class="column is-narrow info-text">
        <h2 v-translate :class="$mq.phone ? 'heading-3' : 'heading-2'">
          Your recovery link has expired
        </h2>
        <p v-translate v-if="errors" :class="$mq.phone ? 'paragraph-m' : 'paragraph-l'" class="confirmation-text">
          Looks like your recovery link has expired or invalid. It's not a problem, you can request another one
        </p>
        <div>
          <span>
            <router-link v-translate :to="resetPasswordRoute" class="button is-primary">
              Request password
            </router-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/triangle-warning';
import 'top20common/distribution/icons/success';

export default {
  props: {
    errors: Array,
    success: Boolean
  },
  computed: {
    isCurrentRouteCandidate() {
      return this.$route.name === 'reset-password-candidate-confirmation';
    },
    resetPasswordRoute() {
      return this.isCurrentRouteCandidate ? {name: 'reset-password-candidate'} : {name: 'reset-password-employer'};
    },
    loginRoute() {
      return this.isCurrentRouteCandidate ? {name: 'login-candidate'} : {name: 'login-employer'};
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.reset-confirm-flex-row {
  display: flex;
  justify-content: center;
  height: auto;
  align-items: flex-start;
  width: 100%;
}

.info-text {
  max-width: 320px;
  padding: 0;
}

.success-image {
  float: right;
  margin-top: -70px;
  min-width: 253px;
}

.is-hidden-mobile {
  height: 276px;
}

.top-wrapper-reset-password {
  height: 100%;
  margin-top: 85px;
  display: flex;
  align-items: flex-start;
}

.confirmation-text {
  padding: 15px 0 25px 0;
}

.column.is-3 {
  text-align: right;
}

@media screen and (min-width: $tablet) {
  .top-wrapper-reset-password {
    align-items: center;
  }
}
</style>
